// Upload a missing NHP into that employee's own Drive folder (Jessica
// Sankhi is the first case). Same wire as idea files: bytes in the body,
// the name in a header — not multipart, and not through `authedWrite`
// because that helper JSON-encodes its body.
import { API_BASE } from './config';
import { authToken } from './auth';
import { withViewAs } from './viewAs';

/** Same ceiling the server enforces, stated here so the refusal happens before
 * a 25 MB upload rather than after it. */
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;

export interface UploadedNhp {
  name: string;
  url: string;
}

export async function uploadPersonNhp(employeeId: number, file: File): Promise<UploadedNhp> {
  if (file.size === 0) throw new Error(`${file.name} is empty`);
  if (file.size > MAX_UPLOAD_BYTES) {
    throw new Error(
      `${file.name} is ${Math.round(file.size / 1048576)} MB — the limit is `
      + `${MAX_UPLOAD_BYTES / 1048576} MB. Put it in Drive and paste the link instead.`,
    );
  }

  const token = authToken.value;
  const res = await fetch(`${API_BASE}${withViewAs(`/api/v1/people/${employeeId}/nhp`)}`, {
    method: 'POST',
    headers: {
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      'content-type': file.type || 'application/octet-stream',
      'x-file-name': encodeURIComponent(file.name),
      'idempotency-key': crypto.randomUUID(),
    },
    body: file,
  });

  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((body as { error?: string }).error || `upload failed (HTTP ${res.status})`);
  }
  return (body as { file: UploadedNhp }).file;
}
